import { useTranslation } from 'react-i18next';
import { AppModal } from './AppModal';
import { AppButton } from './AppButton';
import { useAccountLinkedStore } from '@/stores/accountLinked';

const PROVIDER_LABELS: Record<string, string> = {
  apple: 'Apple',
  google: 'Google',
  email: 'email',
};

/** Tells the user a new sign-in method was merged into their existing account. */
export function AccountLinkedModal() {
  const { t } = useTranslation('common');
  const provider = useAccountLinkedStore((s) => s.provider);
  const dismiss = useAccountLinkedStore((s) => s.dismiss);
  return (
    <AppModal
      open={provider !== null}
      onClose={dismiss}
      size="sm"
      title={t('accountLinked.title')}
      actions={<AppButton onClick={dismiss}>{t('accountLinked.ok')}</AppButton>}
    >
      {t('accountLinked.body', { provider: PROVIDER_LABELS[provider ?? ''] ?? provider })}
    </AppModal>
  );
}
